import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';

Vue.use(Vuex);

export const store = new Vuex.Store({
    namespaced: true,
    modules: {
      ...modules
    }
});
